import {
  Flex,
  Modal,
  ModalOverlay,
  ModalContent,
  Text,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  Image,
  useDisclosure,
} from "@chakra-ui/react";
import { useEffect } from "react";
import { FormButton } from "../components/login/button.component";
import { ModalCancelButton, ModalFooterActions } from "../components/ModalFooter/ModalFooterActions";

interface IModalConfirmProps {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  title: string;
  description: React.ReactNode;
  callback: () => void;
  cancel?: () => void;
  buttonConfirmText?: string;
  buttonCancelText?: string;
  style?: `default` | `delete`;
  size?: `sm` | `md` | `lg` | `xl` | `full`;
}

export const ModalConfirm = (props: IModalConfirmProps) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  useEffect(() => {
    if (props.isOpen) {
      onOpen();
    }
  }, [props.isOpen]);

  const close = () => {
    props.setIsOpen(false);
    onClose();
  };

  const cancel = () => {
    if (props.cancel) {
      props.cancel();
    }

    props.setIsOpen(false);
    onClose();
  };

  const yesOption = () => {
    props.callback();
    close();
  };

  return (
    <>
      {props.style === "delete" ? (
        <Modal closeOnOverlayClick={false} isOpen={isOpen} onClose={cancel} size={props.size ?? "sm"}>
          <ModalOverlay bg="blackAlpha.300" backdropFilter="blur(10px)" alignItems="center" />
          <ModalContent flexGrow={1} flexShrink={1} borderLeft="12px solid #0263FF" borderRadius={8}>
            <ModalHeader padding="16px 24px 8px !important">{props.title}</ModalHeader>
            <ModalCloseButton onClick={cancel} />
            <ModalBody>
              <Flex justifyContent="center" flexDirection="column" gap={5}>
                <Text>
                  {typeof props.description === "string" ? <Text>{props.description}</Text> : props.description}
                </Text>

                <ModalFooterActions>
                  <ModalCancelButton onClick={cancel}>{props.buttonCancelText ?? "Fechar"}</ModalCancelButton>
                  <FormButton
                    onClick={yesOption}
                    width="50%"
                    height={"34px"}
                    color="#EF4444"
                    _hover={{
                      bgColor: "#EF4444",
                      cursor: "pointer",
                      color: "white",
                    }}
                  >
                    {props.buttonConfirmText ?? "sim"}
                  </FormButton>
                </ModalFooterActions>
              </Flex>
            </ModalBody>
          </ModalContent>
        </Modal>
      ) : (
        <Modal closeOnOverlayClick={false} isOpen={isOpen} onClose={close} size="sm">
          <ModalOverlay bg="blackAlpha.300" backdropFilter="blur(10px)" alignItems="center" />
          <ModalContent flexGrow={1} flexShrink={1} borderLeft="12px solid #0263FF" borderRadius={8}>
            <ModalHeader>{props.title}</ModalHeader>
            <ModalCloseButton onClick={cancel} />
            <ModalBody>
              <Flex justifyContent="center" flexDirection="column" gap={5}>
                <Text>
                  {typeof props.description === "string" ? <Text>{props.description}</Text> : props.description}
                </Text>

                <Flex gap={2} flexGrow={1} justifyContent="space-between">
                  <FormButton onClick={yesOption} width="50%">
                    Sim
                  </FormButton>
                  <FormButton onClick={cancel} width="50%">
                    Não
                  </FormButton>
                </Flex>
              </Flex>
            </ModalBody>
          </ModalContent>
        </Modal>
      )}
    </>
  );
};
